import React from 'react';
import { Link } from "react-router-dom";
import PropTypes from 'prop-types';
import pin from 'src/assets/svg/location.svg';
import noImage from 'src/assets/svg/no-image.svg';
import time from 'src/assets/svg/time.svg';
import FavoriteButton from 'src/components/common/FavoriteButton';
import AdTypeBadge from 'src/components/common/AdTypeBadge';
import { calculateAge } from 'src/utils/ageHelper';

const ArticleCard = ({ article }) => {
    const url = '/ad/' + article.id + '/' + article.slug;

  return (
    <div className="flex flex-col justify-evenly w-full xxs:w-[calc(50%-4px)] sm:w-[264px] lg:w-[320px] bg-white border border-gray-200 rounded-lg shadow">
      <div className='p-1 sm:p-4 flex justify-between items-center'>
        <div className='flex items-center gap-2'>
          <img src={time} alt="time" className='w-4 h-4 sm:w-5 sm:h-5' />
          <span className='text-sm sm:text-base'>{article.refreshed_at}</span>
        </div>
        {article.ad_type && (
          <AdTypeBadge adType={article.ad_type} />
        )}
      </div>
      <div className="px-1 sm:px-5 lg:px-10 pb-3 sm:pb-5">
        <Link to={url} className="block">
          <img className="w-full h-auto aspect-video object-cover rounded-lg" src={article.featured_image_url || noImage} alt={article.title} />
        </Link>
      </div>
      <div className="px-1 sm:px-4 pb-3 sm:pb-4">
        <Link to={url}>
          <h5 className="text-base sm:text-2xl text-center font-bold tracking-tight line-clamp-2">{article.title}</h5>
        </Link>
        {(article.city || article.country_name) && (
          <p className='flex justify-center mt-2 mb-2 sm:mb-3'>
            <img src={pin} alt="location" className='w-4 h-4 sm:w-5 sm:h-5' /> 
            <span className='text-[#656565] text-xs sm:text-base ml-2'>
              {article.city && article.country_name ? `${article.country_name}, ${article.city}` : article.country_name || article.city}
            </span>
          </p>
        )}
        {((article.attributes?.['litter-male-count'] > 0 || article.attributes?.['litter-female-count'] > 0) || article.attributes?.['date-of-birth'] || article.ad_type === 'wanted') && (
          <p className='text-[#909090] text-xs sm:text-sm mb-3 sm:mb-4 text-center'>
            {article.attributes?.['litter-male-count'] > 0 && `${article.attributes['litter-male-count']} ${article.attributes['litter-male-count'] > 1 ? 'Males' : 'Male'}`}
            {article.attributes?.['litter-male-count'] > 0 && article.attributes?.['litter-female-count'] > 0 && ' & '}
            {article.attributes?.['litter-female-count'] > 0 && `${article.attributes['litter-female-count']} ${article.attributes['litter-female-count'] > 1 ? 'Females' : 'Female'}`}
            {((article.attributes?.['litter-male-count'] > 0 || article.attributes?.['litter-female-count'] > 0) && (article.attributes?.['date-of-birth'] || article.ad_type === 'wanted')) && ' | '}
            {(article.attributes?.['date-of-birth'] || article.ad_type === 'wanted') && calculateAge(article.attributes?.['date-of-birth'], article.ad_type, article.attributes?.age)}
          </p>
        )}
        <div className={`flex items-center ${article.ad_type !== 'for-adoption' && article.price_formatted ? 'justify-between' : 'justify-end'}`}>
          {article.ad_type !== 'for-adoption' && article.price_formatted && (
            <span className="text-sm sm:text-base leading-[16px] text-white rounded-2xl px-3 sm:px-4 py-1.5 sm:py-2 bg-[#832EE6]">
              {article.price_formatted}
            </span>
          )}
          <FavoriteButton 
            articleId={article.id}
            initialIsFavorited={article.is_favorited}
          />
        </div>
      </div>
    </div>
  );
};

ArticleCard.propTypes = {
  article: PropTypes.shape({
    id: PropTypes.number.isRequired,
    slug: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    refreshed_at: PropTypes.string.isRequired,
    city: PropTypes.string,
    country_name: PropTypes.string,
    price_formatted: PropTypes.string,
    featured_image_url: PropTypes.string || PropTypes.null,
    is_favorited: PropTypes.bool
  }).isRequired
};

export default ArticleCard;